export interface IMarkAsRead{
    aggId:string;
    unread: number;
}

export class MarkAsRead implements IMarkAsRead {
    aggId:string;
    unread: number;
}